import React, { useCallback, useEffect, useState } from "react";
import { Pagination, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import {
  getProductQuestions,
  ProductQuestionItem,
} from "api/ProductQuestions";
import { FilterState } from "./useFilterState";
import { QuestionItem } from "./QuestionItem";

const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

export const QuestionsList = (props: { filters: FilterState }) => {
  const [items, setItems] = useState<ProductQuestionItem[]>([]);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [pending, setPending] = useState(false);

  const fetchData = useCallback(async () => {
    setPending(true);
    try {
      const res = await getProductQuestions({
        processed: props.filters.state.processed,
        marketplace_auth_id: props.filters.state.marketplace_auth_id.length
          ? props.filters.state.marketplace_auth_id
          : undefined,
        search: props.filters.state.search || undefined,
        article: props.filters.state.article || undefined,
        sorting: props.filters.state.sorting,
        page: props.filters.state.page,
      });
      setItems(res.data);
      setTotal(res.total);
      setTotalPage(res.total_page);
      setHasMore(res.hasMore);
    } finally {
      setPending(false);
    }
  }, [props.filters.state]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const paginationTotal = !hasMore
    ? props.filters.state.page
    : totalPage;

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <Pagination
          current={props.filters.state.page}
          onChange={(page) => props.filters.update({ page })}
          total={paginationTotal}
          pageSize={1}
          showSizeChanger={false}
          style={{ display: "inline-block" }}
        />
        <span style={{ marginLeft: 16, lineHeight: "32px" }}>
          Найдено: {total.toLocaleString("ru-RU")}
        </span>
      </div>
      <Spin spinning={pending} indicator={antIcon}>
        {items.map((item) => (
          <QuestionItem key={item.id} data={item} onUpdated={fetchData} />
        ))}
      </Spin>
      <Pagination
        current={props.filters.state.page}
        onChange={(page) => props.filters.update({ page })}
        total={paginationTotal}
        pageSize={1}
        showSizeChanger={false}
        style={{ marginTop: 16 }}
      />
    </>
  );
};
